import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { UtilsService } from 'src/app/core/services/utils.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
  selector: 'app-ag-output-files-cell-renderer',
  templateUrl: './ag-output-files-cell-renderer.component.html',
  styleUrls: ['./ag-output-files-cell-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent],
})
export class AgOutputFilesCellRendererComponent {
  params: any;
  files: any;

  private utilsService = inject(UtilsService);

  agInit(params: any) {
    this.params = params;
    this.files = params.data.files;
  }

  refresh(params: any) {
    this.params = params;
    this.files = params.data.files;
  }

  getFileTypeIcon(fileName: string): IconProp {
    return this.utilsService.getFileTypeIcon(fileName);
  }

  downloadLog(fileName: string): string {
    return this.utilsService.downloadFile(fileName);
  }
}
